import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function useGetModemDetails(params: { id: number }) {
  return useQuery({
    ...queries.modems.modemDetails({ id: params.id }),
    enabled: !!params.id,
    select: (data) => data?.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
